import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

export type ChargesWorkflowsContextState = {
  generateInvoiceFlow: Workflow
}

const [ChargesWorkflowsContext, useChargesWorkflowsContextValue] =
  createContext<ChargesWorkflowsContextState>({
    name: 'ChargesWorkflowsContext',
  })

export const ChargesWorkflowsProvider = ({ children }: PropsWithChildren) => {
  const [isGenerateInvoiceFlowOpen, setIsGenerateInvoiceFlowOpen] =
    useState(false)

  const value: ChargesWorkflowsContextState = {
    generateInvoiceFlow: {
      open: () => setIsGenerateInvoiceFlowOpen(true),
      close: () => setIsGenerateInvoiceFlowOpen(false),
      isOpen: isGenerateInvoiceFlowOpen,
    },
  }

  return (
    <ChargesWorkflowsContext.Provider value={value}>
      {children}
    </ChargesWorkflowsContext.Provider>
  )
}

export { useChargesWorkflowsContextValue }
